import React from 'react';
import { Badge, makeStyles } from '@material-ui/core';

import {
  getQuizSubmoduleName,
  getQuizUnitName,
} from 'resources/common/quizProgress/quizPathUtils';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  title: {
    fontWeight: 'bold',
    marginBottom: '4px',
    paddingRight: '55px',
  },
  path: {
    fontSize: '0.75rem',
    color: '#666',
    paddingRight: '60px',
  },
  badge: {
    '& .MuiBadge-badge': {
      top: 8,
      right: 8,
      padding: '4px 5px',
      fontSize: '0.7rem',
      height: 'auto',
      borderRadius: '12px',
      fontWeight: '500',
    },
  },
});

const QuizTitle = ({ record }) => {
  const classes = useStyles();
  const unit = getQuizUnitName(record);
  const submodule = getQuizSubmoduleName(record);
  const title = record.title || unit || record.id;

  const titleBlock = (
    <div>
      <div className={classes.title}>{title}</div>
      {submodule ? <div className={classes.path}>{submodule}</div> : null}
    </div>
  );

  return (
    <div className={classes.container}>
      {record.required ? (
        <Badge
          className={classes.badge}
          color="primary"
          badgeContent="Required"
          overlap="rectangular"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {titleBlock}
        </Badge>
      ) : (
        titleBlock
      )}
    </div>
  );
};

export default QuizTitle;
